import { useAdminGetProductsQuery } from "@diditusa/shared/api/adminApi";
import { OptionPricing } from "@diditusa/shared/types/productTypes";
import LoadingIndicator from "@diditusa/shared/web_components/LoadingIndicator/loadingIndicator";
import {
  Box,
  Button,
  Paper,
  Typography,
  Container,
  Link as MuiLink,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "@diditusa/shared/api/apiUtils";

export default function Products() {
  const navigate = useNavigate();
  const { data: products, ...getProductsState } = useAdminGetProductsQuery();

  if (getProductsState.isLoading) {
    return <LoadingIndicator isVisible={getProductsState.isLoading} />;
  }

  if (getProductsState.isError) {
    return (
      <p>Error loading products ${getErrorMessage(getProductsState.error)}</p>
    );
  }

  if (!products || products.length === 0) {
    return <Typography>No products found. Add some now.</Typography>;
  }

  const getOnProductClick = (productId: number) => {
    return () => navigate(`/products/${productId}`);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 5, display: "flex" }}>
      <Box flex={1}>
        <Box display="flex" justifyContent={"space-between"} p={2}>
          <Typography fontWeight={700} fontSize={32} color="#1C1D22">
            Products
          </Typography>
          <Button
            variant="contained"
            sx={{
              borderRadius: 999,
              backgroundColor: "#EEEFF2",
              color: "#1C1D22",
            }}
            onClick={() => navigate("/products/new")}
          >
            New Product
          </Button>
        </Box>

        {products.map((product) => (
          <Paper
            key={product.title}
            elevation={0}
            sx={{ display: "flex", p: 2, m: 2, gap: 2, borderRadius: 3 }}
          >
            <Box
              flex={2}
              display="flex"
              flexDirection="column"
              textAlign="start"
            >
              <MuiLink
                onClick={getOnProductClick(product.id)}
                underline="hover"
                sx={{ cursor: "pointer" }}
              >
                <Typography fontWeight={700} color="#1C1D22">
                  {product.title}
                </Typography>
              </MuiLink>
              <Typography fontSize={14} color="#3C3F4A" lineHeight={3}>
                {product.description}
              </Typography>
              {product.optionPricing?.map((p: OptionPricing) => (
                <Button
                  variant="contained"
                  sx={{
                    mt: 1,
                    width: "fit-content",
                    backgroundColor: "#EEEFF2",
                    color: "#1C1D22",
                    borderRadius: 999,
                  }}
                >
                  ${p.unitAmount / 100}
                </Button>
              ))}
            </Box>
            <Box
              flex={1}
              sx={{
                backgroundImage: `url(${product.imageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: 3,
                aspectRatio: "16/9",
              }}
            />
          </Paper>
        ))}
      </Box>
    </Container>
  );
}
